
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import AppButton from '@/components/Common/AppButton.vue';
import { useQuery } from '@vue/apollo-composable';
import { GetIcoReportDocument, IcoReport } from '@/graphql/generated-operations';
import { formatTime } from '@/helpers/formatTime';

@Options({
  components: {
    AppButton,
  }
})
export default class ExportIcoTable extends Vue {

  @Prop()
  dateFrom!: string;

  @Prop()
  dateTo!: string;

  loading = true;

  report: IcoReport[] = [];

  created() {
    const { onResult: onDataResult } = useQuery(GetIcoReportDocument, {
      dateFrom: this.dateFrom,
      dateTo: this.dateTo,
    });

    onDataResult(queryResult => {
      this.report = queryResult.data.getIcoReport;

      this.loading = false;
    });
  }

  getTime(minutes: number)
  {
    return formatTime({
      hours: Math.floor(minutes / 60),
      minutes: minutes % 60,
    });
  }

}
